"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosBottleUpdateInputSchema = exports.APosBottleCreateInputSchema = exports.APosBottleSchema = exports.APosBottleMaterialSchema = exports.APosBottleDefaultProductTypeSchema = exports.APosBottleStyleSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
const oil_blending_stock_schema_1 = require("./oil-blending-stock.schema");
/**
 * Module 29 — Oil Blending
 * Bottle / container catalog. PK = tenantId, SK = bottleId (bot_{ulid12}).
 *
 * STOCK MODEL — 2026-06-04 redesign:
 * Bottles are sellable standalone but still live in the oil-blending parallel
 * rail — NOT in the Products/Variants pipeline. Stock is counted (each), per
 * location, on the row. `linked_variant_id` is legacy.
 *
 * `tax_fee_ids` carries the list of tax/fee record IDs that apply when this
 * bottle is sold standalone (i.e. not as part of a blend — blend sales use
 * the blend pricing config's `taxes_by_blend_category.bottles`).
 */
const decimal3dp = (val) => Number.isFinite(val) && Math.round(val * 1000) / 1000 === val;
exports.APosBottleStyleSchema = zod_1.z.enum([
    'standard', 'roll_on', 'gift', 'spray',
    'amber_glass', 'crystal', 'other',
]);
exports.APosBottleDefaultProductTypeSchema = zod_1.z.enum(['body_oil', 'essential_oil']);
exports.APosBottleMaterialSchema = zod_1.z.enum(['glass', 'aluminum', 'plastic', 'crystal', 'other']);
exports.APosBottleSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    bottleId: id_schema_1.EntityIdSchema.describe('Format: bot_{ulid12}'),
    name: zod_1.z.string().min(1).max(120),
    description: zod_1.z.string().max(2000).optional(),
    size_ml: zod_1.z.number().positive().refine(decimal3dp, 'must be 3dp'),
    style: exports.APosBottleStyleSchema,
    material: exports.APosBottleMaterialSchema.optional(),
    color: zod_1.z.string().max(40).optional(),
    brand_id: id_schema_1.EntityIdSchema.optional(),
    sku: zod_1.z.string().max(60).optional(),
    // POS-scannable barcode — the GSI on this field is what the POS register
    // (phase 2) hits to ring a standalone bottle sale.
    barcode: zod_1.z.string().max(64).optional(),
    image_url: zod_1.z.string().url().optional(),
    retail_price_cents: zod_1.z.number().int().nonnegative(),
    cost_cents: zod_1.z.number().int().nonnegative(),
    // Tax/fee records that apply on standalone sale.
    tax_fee_ids: zod_1.z.array(zod_1.z.string()).default([]),
    // Pre-select for that product type in the builder. null = no default.
    is_default_for_product_type: exports.APosBottleDefaultProductTypeSchema.nullable().optional(),
    // When true, a sale of this bottle creates a CustomerOwnedBottle row.
    is_refillable: zod_1.z.boolean().default(false),
    is_visible_to_customers: zod_1.z.boolean().default(true),
    is_active: zod_1.z.boolean().default(true),
    sort_order: zod_1.z.number().int().nonnegative().default(0),
    stock_by_location: oil_blending_stock_schema_1.APosBottleStockByLocationSchema.default({}),
    linked_variant_id: id_schema_1.EntityIdSchema.optional().describe('LEGACY — pre-2026-06-04 records only.'),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosBottleCreateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(120),
    description: zod_1.z.string().max(2000).optional(),
    size_ml: zod_1.z.number().positive().refine(decimal3dp, 'must be 3dp'),
    style: exports.APosBottleStyleSchema,
    material: exports.APosBottleMaterialSchema.optional(),
    color: zod_1.z.string().max(40).optional(),
    brand_id: id_schema_1.EntityIdSchema.optional(),
    sku: zod_1.z.string().max(60).optional(),
    barcode: zod_1.z.string().max(64).optional(),
    image_url: zod_1.z.string().url().optional(),
    retail_price_cents: zod_1.z.number().int().nonnegative(),
    cost_cents: zod_1.z.number().int().nonnegative(),
    tax_fee_ids: zod_1.z.array(zod_1.z.string()).optional(),
    is_default_for_product_type: exports.APosBottleDefaultProductTypeSchema.nullable().optional(),
    is_refillable: zod_1.z.boolean().optional(),
    is_visible_to_customers: zod_1.z.boolean().optional(),
    is_active: zod_1.z.boolean().optional(),
    sort_order: zod_1.z.number().int().nonnegative().optional(),
});
exports.APosBottleUpdateInputSchema = exports.APosBottleCreateInputSchema.partial();
//# sourceMappingURL=bottle.schema.js.map